import { Routes } from '@models/route';
import { lazy } from 'react';

const SearchSwyft = lazy(() =>
  import('@pages/swyft/search-swyft').then((p) => ({
    default: p.SearchSwyft
  }))
);

const ViewSwyft = lazy(() =>
  import('@pages/swyft/view-swyft').then((p) => ({
    default: p.ViewSwyft
  }))
);

export const SwyftRoutes: Routes = [
  {
    path: '/swyft',
    component: SearchSwyft,
    children: [
      {
        path: ':id',
        component: ViewSwyft
      }
    ]
  }
];
